import {
  Injectable,
  inject
} from '@angular/core';

import {
  isPlatformBrowser
} from '@angular/common';

import {
  PLATFORM_ID
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Observable,
  tap
} from 'rxjs';

import {
  environment
} from '../../environments/environment';


export interface LoginRequest {

  email: string;

  senha: string;

}


export interface LoginResponse {

  token: string;

  tipo: string;

  nome: string;

  email: string;

}


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly apiUrl =
    `${environment.apiUrl}/auth`;

  private readonly tokenKey =
    'admin_token';

  private readonly platformId =
    inject(PLATFORM_ID);


  constructor(
    private http: HttpClient
  ) {}

  login(
    request: LoginRequest
  ): Observable<LoginResponse> {

    return this.http
      .post<LoginResponse>(
        `${this.apiUrl}/login`,
        request
      )
      .pipe(

        tap(response => {

          if (
            !isPlatformBrowser(
              this.platformId
            )
          ) {
            return;
          }


          localStorage.setItem(
            this.tokenKey,
            response.token
          );


          localStorage.setItem(
            'admin_nome',
            response.nome
          );


          localStorage.setItem(
            'admin_email',
            response.email
          );

        })

      );

  }

  getToken(): string | null {

    if (
      !isPlatformBrowser(
        this.platformId
      )
    ) {

      return null;

    }


    return localStorage.getItem(
      this.tokenKey
    );

  }

  estaAutenticado(): boolean {

    return !!this.getToken();

  }

  logout(): void {

    if (
      !isPlatformBrowser(
        this.platformId
      )
    ) {

      return;

    }


    localStorage.removeItem(
      this.tokenKey
    );


    localStorage.removeItem(
      'admin_nome'
    );


    localStorage.removeItem(
      'admin_email'
    );

  }

  getNome(): string | null {

    if (
      !isPlatformBrowser(
        this.platformId
      )
    ) {

      return null;

    }


    return localStorage.getItem(
      'admin_nome'
    );

  }

}
